/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { FailCardTransactionCardTransactionTransactionRecordListInner } from './fail-card-transaction-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface FailCardTransactionCardTransaction
 */
export interface FailCardTransactionCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionType': FailCardTransactionCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionStatus': FailCardTransactionCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<FailCardTransactionCardTransactionTransactionRecordListInner>}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionRecordList': Array<FailCardTransactionCardTransactionTransactionRecordListInner>;
}

export const FailCardTransactionCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type FailCardTransactionCardTransactionTransactionTypeEnum = typeof FailCardTransactionCardTransactionTransactionTypeEnum[keyof typeof FailCardTransactionCardTransactionTransactionTypeEnum];
export const FailCardTransactionCardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type FailCardTransactionCardTransactionTransactionStatusEnum = typeof FailCardTransactionCardTransactionTransactionStatusEnum[keyof typeof FailCardTransactionCardTransactionTransactionStatusEnum];


